import styled from 'styled-components'
import colors from 'globals/colors'
import { MailRawIcon, PhoneRawIcon, EurosIcon } from 'components/Icons'

export const ClientCompany = styled.div`
  line-height: 24px;
  font-size: 18px;
  font-weight: bold;
`

export const ClientName = styled.div`
  line-height: 32px;
`

export const ContactWrapper = styled.div`
  margin-top: 24px;
`

export const RegistrationDate = styled.div`
  line-height: 32px;
  font-size: 12px;
  color: ${colors.grey};
`

export const HorizontalWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const TagList = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
`

interface TagProps {
  color?: string
}

export const Tag = styled.div<TagProps>`
  height: 28px;
  font-size: 14px;
  font-weight: 600;
  background: ${colors.lighterGrey};
  border-radius: 4px;
  padding: 0 10px;
  margin-top: 9px;
  margin-right: 9px;
  display: flex;
  align-items: center;
  & > svg {
    margin-left: 6px;
  }
  ${(props) => props.color == 'red' && `color: ${colors.reddishPink};`}
`

export const MailIcon = styled(MailRawIcon)`
  margin-right: 8px;
`

export const PhoneIcon = styled(PhoneRawIcon)`
  margin-right: 8px;
  margin-left: 32px;
`

export const FundsSourceIcon = styled(EurosIcon)`
  margin-right: 8px;
  margin-left: 32px;
`
